import { Fiskaly } from "@data-types";
import { getDisplayedAmount } from "@utils";

import { DateTime } from "luxon";
import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";

export default observer(function FiskalySection(props: {
	metadata: Fiskaly;
	currency: string;
}) {
	const { t } = useTranslation("mybets");

	const metaData: Fiskaly = props.metadata;
	if (metaData.fiskalyReceiptNumber == null) {
		metaData.hints = ["Sicherheitseinrichtung ausgefallen"];
	}

	return (
		<div className="table--bet__details table--bet__fiscalization">
			{props.metadata.timeSignature && (
				<div className="bet__details__row table--bet__fiscalization__row">
					<div className="bet__details__col table--bet__fiscalization__data">
						{t("ITEM.FISKALY_DATE")}:
					</div>
					<div className="bet__details__col table--bet__fiscalization__data">
						{DateTime.fromISO(
							props.metadata.timeSignature + "Z"
						).toLocaleString(DateTime.DATETIME_SHORT)}
					</div>
				</div>
			)}
			{props.metadata.fiskalyReceiptNumber && (
				<div className="bet__details__row table--bet__fiscalization__row">
					<div className="bet__details__col table--bet__fiscalization__data">
						{t("ITEM.FISKALY_RECIPET_NUMBER")}:
					</div>
					<div className="bet__details__col table--bet__fiscalization__data">
						{props.metadata.fiskalyReceiptNumber}
					</div>
				</div>
			)}
			{props.metadata.fiskalyCashRegisterSerialNumber && (
				<div className="bet__details__row table--bet__fiscalization__row">
					<div className="bet__details__col table--bet__fiscalization__data">
						{t("ITEM.FISKALY_SERIAL_NUMBER")}:
					</div>
					<div className="bet__details__col table--bet__fiscalization__data">
						{props.metadata.fiskalyCashRegisterSerialNumber}
					</div>
				</div>
			)}

			{props.metadata.grossAmountZero && (
				<div className="bet__details__row table--bet__fiscalization__row">
					<div className="bet__details__col table--bet__fiscalization__data">
						{t("ITEM.GROSS_AMOUNT_STANDARD")}:
					</div>
					<div className="bet__details__col table--bet__fiscalization__data">
						{getDisplayedAmount(
							+props.metadata.grossAmountZero,
							props.currency
						)}
					</div>
				</div>
			)}

			{props.metadata.hints && props.metadata.hints.length > 0 && (
				<div className="bet__details__row table--bet__fiscalization__row">
					<div className="bet__details__col table--bet__fiscalization__data">
						{t("ITEM.HINTS")}:
					</div>
					<div className="bet__details__col table--bet__fiscalization__data">
						{props.metadata.hints}
					</div>
				</div>
			)}
		</div>
	);
});
